<template>
    <div class="card" v-show="loaded">

        <div class="card-header">
            <div class="row">
                <div class="col-6">
                    <h3 class="mb-0 text-uppercase">{{ $t('common.resources') }}</h3>
                </div>
                <div class="col-6 text-right">
                    <base-button type="primary" size="sm" @click="ctrl.create()" v-if="canEdit">
                        <span class="btn-inner--icon"><i class="tim-icons icon-e-add"></i></span>
                        <span class="btn-inner--text">{{ $t('resources.new') }}</span>
                    </base-button>
                </div>
            </div>
        </div>

        <p class="card-body text-sm" v-if="empty">{{ $t('resources.no-resource') }}</p>

        <div v-if="!empty">
            
            <el-table-draggable handle=".handle" @drop="dropped">
                <el-table class="table-responsive table-flush"
                        :show-header="false"
                        :data="ctrl.rows">

                    <el-table-column :label="$t('common.resource')" class-name="name">
                        <template v-slot="{row}">
                            <h4 class="mb-0">
                                <a :href="row.url" target="_blank" class="font-weight-normal">
                                    {{ row.name }}
                                </a>
                                <small v-if="row.confidential">
                                    <i class="fas fa-lock ml-1"></i>
                                </small>
                            </h4>
                        </template>
                    </el-table-column>

                    <el-table-column align="right" width="150" class-name="actions" v-if="canEdit">
                        <template v-slot="{row}">
                            <div class="table-actions">

                                <a href="#" class="table-action text-danger" @click.prevent="ctrl.delete(row.id)">
                                    <i class="tim-icons icon-simple-remove"></i>
                                </a>

                                <a href="#" class="table-action text-primary" @click.prevent="ctrl.update(row.id)">
                                    <i class="tim-icons icon-pencil"></i>
                                </a>

                                <a href="#" class="table-action text-default handle">
                                    <i class="tim-icons icon-drag-31"></i>
                                </a>

                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-table-draggable>
        </div>

        <portal to="modals">

            <form-modal v-model="ctrl.modals.edit"
                :title="$t('common.resource')"
                :loading="ctrl.form.loading"
            >
                <resource-form v-model="ctrl.form.data"
                    :errors="ctrl.form.errors"
                    :modal="ctrl.modals.edit"
                >
                </resource-form>
            </form-modal>

            <confirm-modal v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('resources.delete-confirm') }}</p>
            </confirm-modal>

        </portal>

    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import ResourceForm from './ResourceForm'
    import ElTableDraggable from 'element-ui-el-table-draggable'

    export default {

        components: {
            ResourceForm, ElTableDraggable
        },

        props: {
            degree: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/astral/api/front/resources',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    query: {
                        filters: { degree_id: this.$route.params.id },
                        sort: ['position'],
                    }
                }),
            }
        },

        computed: {

            empty() {
                return this.ctrl.rows.length == 0
            },

            shared() {
                return this.degree.shared && this.$auth.user.owner_id && this.$auth.user.owner_id != this.degree.owner_id
            },

            canEdit() {
                return !this.shared && this.degree.status != 'archived'
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
            })
        },

        methods: {

            dropped(data) {
                let ids = data.list.map(item => item.id)
                axios.post('/astral/api/front/degrees/'+this.$route.params.id+'/reorder-resources', { ids })
                .then(resp => {
                    this.ctrl.list()
                })
                .catch(err => {
                    //this.ctrl.list()
                    this.$auth.handleErrorVm(err, this)
                });
            },
            
            mapData(resource) {
                return {
                    id: resource ? resource.id : null,
                    name: resource ? resource.name : null,
                    url: resource ? resource.url : null,
                    description: resource ? resource.description : null,
                    confidential: resource ? resource.confidential : true,
                }
            },

            unmapData(data) {
                data.degree_id = this.$route.params.id
                return data
            }
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }

    .card >>> th.actions,
    .card >>> td.actions {
        padding-right: 1.5rem;
    }
    
</style>